export function Not(value: any): Boolean {
    return !value;
}
